// const ApexCharts = require('apexcharts');
import moment from 'moment';
import Api from './Api';
import { parseUnits, submitsToHashrate } from './utils';
import { openModal } from './modal';
import { createModalApp } from './components/JoinPartyModal.mjs';
import { createApp as createTicketApp } from './pages/Ticketpage.mjs';
import { createApp as createPartyDetailsPage } from './pages/PartyDetailsPage.mjs';
import { createModalApp as createBuyTicketModalApp } from './components/BuyTicketModal.mjs';

export default async function run(page = '') {

    if (page == 'ticket') {
        let app = createTicketApp();
        app.mount('#ticket-app');
        return;
    } else if (page == 'party-details-page') {
        let app = createPartyDetailsPage();
        app.mount('#party-details-page');
        return;
    }

    const store = PetiteVue.reactive({
        modal: false,
    });

    const buyModal = createBuyTicketModalApp('#buy-ticket-modal', store);
    buyModal.mount('#buy-ticket-modal');
    document.querySelector('a.buy-ticket-btn').addEventListener('click', (e) => {
        e.preventDefault();
        openModal('#buy-ticket-modal');
        store.modal = true;
    });

    


    const joinModalStore = PetiteVue.reactive({
        modal: false,
        partyId: null
    });


    document.querySelectorAll('a.join-party-btn').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            openModal('#join-mining-modal');
            joinModalStore.modal = true;
            joinModalStore.partyId = btn.getAttribute('party-id');
        });
    });

    const joinModal = createModalApp('#join-mining-modal', joinModalStore);
    joinModal.mount('#join-mining-modal');

    updatePartyTickers();
    setInterval(updatePartyTickers, 1000);

    updatePartyHashrates();
    setInterval(updatePartyHashrates, 15000);
}

function updatePartyTickers() {
    const tickers = document.querySelectorAll('.party-ticker');
    tickers.forEach(async (ticker) => {
        const dateStr = ticker.getAttribute('launch-date');
        const launchDate = moment(dateStr);
        const now = moment();
        const diff = launchDate.diff(now);
        if (diff < 0) {
            ticker.innerText = '00:00';
            return;
        }

        
        const duration = moment.duration(diff);
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        ticker.innerText = `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    });
}

function updatePartyHashrates() {
    // search for <tr class="ongoing-party-row" data-party-id="<%= party._id %>">
    const rows = document.querySelectorAll('tr.ongoing-party-row');
    rows.forEach(async (row) => {
        const partyId = row.getAttribute('data-party-id');
        const hashrateEl = row.querySelector('.party-speed');
        if (!partyId || !hashrateEl) return;

        try {
            const res5M = await Api.party.generatedWork(partyId, 5);
            let shares = 0;
            for (const rig in res5M) {
                shares += res5M[rig].work;
            }

            if (shares > 0) {
                row.classList.add('is-active');
            } else {
                row.classList.remove('is-active');
            }

            let tmpHashrate = submitsToHashrate(shares, 5*60);
            let hashrate5M = parseUnits(tmpHashrate);

            hashrateEl.innerText = hashrate5M;


        } catch (error) {
            console.error('Error fetching hashrate:', error);
            hashrateEl.innerText = 'N/A';
        }

        const workEl = row.querySelector('.party-work');
        if (!workEl) return;
    
        try {
            const party = await Api.party.get(partyId);
            let txt = '(' + Math.round(party.workGenerated/party.workPaid*1000)/10 + '%)';
            workEl.innerText = txt;

            const progressBar = row.querySelector('.party-work-progress .progress-bar');
            if (progressBar) {
                const progress = Math.round(party.workGenerated / party.workPaid * 100);
                progressBar.style.width = `${progress}%`;
                progressBar.setAttribute('aria-valuenow', progress);
            }
        } catch (error) {
            console.error('Error fetching hashrate:', error);
            hashrateEl.innerText = 'N/A';
        }
    });
}